import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { EOrderTypeId } from "utils/payment";

type TInput = {
  firstName: string;
  lastName: string;
  birthDay: string;
};

type TOutput = {
  personId: number;
  orderTypeId: EOrderTypeId;
  status: string;
};

export default class NewSelfCheckApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;

  resolveUri(): string {
    return `/fe-api/user/renter-advanced`;
  }

  mapRequestData(input: TInput): any {
    return {
      firstname: input.firstName,
      surname: input.lastName,
      birthdate: input.birthDay,
    };
  }

  mapResponseData(_: number, data: any): TOutput {
    return {
      personId: data.person_id,
      orderTypeId: data.order_type_id as EOrderTypeId,
      status: data.status,
    };
  }
}
